import { render, staticRenderFns } from "./ProjCards.vue?vue&type=template&id=08be71c2"
import script from "./ProjCards.vue?vue&type=script&lang=ts"
export * from "./ProjCards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports